import React from 'react';
import {connect} from 'react-redux';

import {dynamic} from 'components/__helpers/dynamic/dynamic';
import {ApplicationStoreType} from 'reducers';
import {getIsTryOnVisible} from 'selectors/tryOnVisibility/tryOnVisibility';
import {getParentProduct, getActiveChildrenProductId} from 'selectors/product/product';
import {SimpleProductFrameMSType, WindowProductMSType} from 'constants/flow/flowTypesProduct';

const TryOn = dynamic(
    /* #__LOADABLE__ */ () =>
        import(/* webpackChunkName: "tryOn" */ 'features/tryOn/components/tryOn'),
    'TryOnSSRConnectedDynamic',
);

const PerfectTryOnConnected = dynamic(
    /* #__LOADABLE__ */ () =>
        import(
            /* webpackChunkName: "perfectTryOn" */ 'features/perfectTryOn/components/perfectTryOn'
        ),
    'PerfectTryOnConnected',
);

export type PropsType = {
    isVisible: boolean;
    page: string;
    parentProduct: WindowProductMSType;
    activeProductId: number;
};

/**
 * Tryon wrapper to load it dynamic
 * @constructor
 */
export const TryOnWrapper: React.FC<PropsType> = ({
    isVisible,
    page,
    parentProduct,
    activeProductId,
}) => {
    if (!isVisible && page !== 'category') return null;
    const currentProduct = parentProduct?.children?.[activeProductId] as SimpleProductFrameMSType;

    if ((page === 'product' || page === 'category') && currentProduct?.is3dModelAvailable) {
        return <PerfectTryOnConnected />;
    }

    return <TryOn />;
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
export const mapStateToProps = (store: ApplicationStoreType) => ({
    isVisible: getIsTryOnVisible(store),
    page: store.pageApp.page,
    parentProduct: getParentProduct(store),
    activeProductId: getActiveChildrenProductId(store),
});

export const TryOnWrapperConnected = connect(mapStateToProps)(TryOnWrapper);
